
export enum EDocumentType {
    AccessPicture = 1,
    GeneralPicture = 2,
    UpstreamPicture = 3,
    DownstreamPicture = 4,
    OtherPicture = 5,
    SchemaStation = 6,
    SEEEExport = 7,
    SEEEResult = 8,
    OmnidiaResult = 9,
    RapportPrelevementExcel = 10,
    RapportEssaiExcel = 11,
    RapportInterpretationExcel = 12,
    StationMap = 13,
    SEEEIBGDCEResult = 14,
    SEEEODIResult = 15,
    RapportPrelevementPDF = 16,
    RapportEssaiPDF = 17,
    RapportInterpretationPDF = 18,
    ImportInterventions = 19,
    EBIOCE2018 = 20,
    SaisieMinvCE = 21,
    SoutienMinvCE = 22,
    SoutienDiat = 23,
    ImportLacTaxons = 24,
    ImportIPLAC = 25,
    RapportInterpretationLacEauXls = 26,
    RapportInterpretationLacEauPdf = 27,
    RapportEssaiLacPhytoXls = 28,
    RapportEssaiLacPhytoPdf = 29,
    RapportInterpretationLacPhytoXls = 30,
    RapportInterpretationLacPhytoPdf = 31,
    /** CARASSO */
    ExportStandardLac = 32,
    SaisieMPhytCE = 33,
    FeuillePaillasseTri = 34,
    IBMRTaxonPicture = 35,

    RapportEssaiLacEauXls = 36,
    RapportEssaiLacEauPdf = 37,

    DonneesSonde = 38,
    ImportSubstratIML = 39,

    RapportInterpretationLacEauSyntheseXls = 40,
    RapportInterpretationLacEauSynthesePdf = 41,
    ResultatSEEEI2M2CEP = 42,
    BackupTaxonIBMR = 43,

    ImportSuiviHydroIML = 44,
    ImportAbiotiqueIML = 45,
    PhotoLotAjustage = 46,
    PhotoSamplingPoint = 47
}
